import { useContext, useMemo } from 'react';
import { Player, PlayerGameStatus } from '../API';
import { HostSessionContext } from '../contexts/HostSessionContext';

export function useHostSessionControls() {
  return useContext(HostSessionContext);
}

export function useState() {
  return useContext(HostSessionContext).state;
}

export function useSession() {
  return useContext(HostSessionContext).session;
}

export function useSessionId() {
  return useContext(HostSessionContext).sessionId;
}

export function useRound() {
  return useContext(HostSessionContext).currentRound;
}

export function useSharingPlayer() {
  const { players } = useContext(HostSessionContext);

  return useMemo(() => {
    const sharingPlayer = players.find((player) => {
      if (player === null) return false;
      return player.gameStatus === PlayerGameStatus.SHARING;
    }) as Player;

    if (!sharingPlayer) {
      return null;
    }

    return sharingPlayer;
  }, [players]);
}

export function useSharedPlayers() {
  const { players } = useContext(HostSessionContext);

  return useMemo(() => {
    return players.filter((player) => {
      if (player === null) return false;
      return player.gameStatus === PlayerGameStatus.SHARED;
    });
  }, [players]);
}

export function usePlayers() {
  return useContext(HostSessionContext).players;
}

export function useRoundArtwork() {
  return useContext(HostSessionContext).artwork;
}

export function useReactions() {
  return useContext(HostSessionContext).reactions;
}

export function useSetSharingPlayer() {
  return useContext(HostSessionContext).setSharingPlayer;
}

export function useStartSession() {
  return useContext(HostSessionContext).startSession;
}

export function useNextGame() {
  return useContext(HostSessionContext).nextGame;
}

export function useEndSession() {
  return useContext(HostSessionContext).endSession;
}

export function useSetEnding() {
  return useContext(HostSessionContext).setEnding;
}
